import React from 'react';
import LegalPage from './LegalPage';

const PrivacyPolicy = () => {
  return (
    <LegalPage title="Privacy Policy">
      <p>Last updated: April 30, 2026</p>
      
      <h2 style={{ color: '#111827', marginTop: '2rem', marginBottom: '1rem' }}>1. Introduction</h2>
      <p>Welcome to trueExams. We are committed to protecting your personal information and your right to privacy.</p>
      
      <h2 style={{ color: '#111827', marginTop: '2rem', marginBottom: '1rem' }}>2. Information We Collect</h2>
      <p>We collect personal information that you provide to us such as name, address, contact information, and passwords.</p>
      
      <h2 style={{ color: '#111827', marginTop: '2rem', marginBottom: '1rem' }}>3. How We Use Your Information</h2>
      <p>We use personal information collected via our platform for a variety of business purposes described below.</p>
      <ul style={{ paddingLeft: '1.5rem', marginTop: '1rem' }}>
        <li>To facilitate account creation and logon process.</li>
        <li>To send administrative information to you.</li>
        <li>To fulfill and manage your orders.</li>
      </ul>

      <h2 style={{ color: '#111827', marginTop: '2rem', marginBottom: '1rem' }}>4. Sharing Your Information</h2>
      <p>We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations.</p>
    </LegalPage>
  );
};

export default PrivacyPolicy;
